import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  PemantauanTerapiGizi,
  PemantauanTerapiGiziHeaderRequest,
  PemantauanTerapiGiziItemRequest
} from "@/types/pemantauan_terapi_gizi";

function fail(err) {
  ErrorAlert.showErrorAlert(err);

  return Promise.reject(err);
}

async function getByRegister(registerId: string): Promise<PemantauanTerapiGizi | null> {
  const response = await http.getData(`/register/${registerId}/pemantauan-terapi-gizi`).catch(fail);

  return response.data.data;
}

async function create(data: { register_id: string; pasien_rm: string; unit_id: string | null }): Promise<PemantauanTerapiGizi> {
  const response = await http.postData("/pemantauan-terapi-gizi", data).catch(fail);

  return response.data.data;
}

async function update(id: number, data: PemantauanTerapiGiziHeaderRequest): Promise<PemantauanTerapiGizi> {
  const response = await http.putData(`/pemantauan-terapi-gizi/${id}`, data).catch(fail);

  return response.data.data;
}

async function storeItem(id: number, data: PemantauanTerapiGiziItemRequest): Promise<PemantauanTerapiGizi> {
  const response = await http.postData(`/pemantauan-terapi-gizi/${id}/item`, data).catch(fail);

  return response.data.data;
}

async function updateItem(id: number, itemId: number, data: PemantauanTerapiGiziItemRequest): Promise<PemantauanTerapiGizi> {
  const response = await http.putData(`/pemantauan-terapi-gizi/${id}/item/${itemId}`, data).catch(fail);

  return response.data.data;
}

async function deleteItem(id: number, itemId: number): Promise<PemantauanTerapiGizi> {
  const response = await http.deleteData(`/pemantauan-terapi-gizi/${id}/item/${itemId}`).catch(fail);

  return response.data.data;
}

async function verify(id: number, password: string): Promise<PemantauanTerapiGizi> {
  const response = await http.postData(`/pemantauan-terapi-gizi/${id}/verifikasi`, { password }).catch(fail);

  return response.data.data;
}

function print(id: number) {
  window.open(`${http.getAPI()}/pemantauan-terapi-gizi/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  create,
  update,
  storeItem,
  updateItem,
  deleteItem,
  verify,
  print
};
